/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import TagsPage from 'flarum/tags/components/TagsPage';
import CreateReviewPrimaryButton from '../components/CreateReviewPrimaryButton';

export default function () {
	extend(IndexPage.prototype, 'sidebarItems', function (items) {
		if (app.current.matches(TagsPage)) {
			// Reviews outrank "Start Discussion" here.
			items.setPriority('newDiscussion', 2);

			items.add('newReview', <CreateReviewPrimaryButton />, 1);
		}
	});
}
